export const ApiUrls = {
  clinicLogsGetApi: (clinicGuid: string) =>
    `admins/admin-panel/clinics/${clinicGuid}/logs`,
} as const;
